import { useState, useEffect } from "react";
import { apiGet } from "../../services/api.service";

interface Country {
	country_id: number;
	country_name: string;
	nationality: string;
	is_eu: boolean;
}

export function useGetCountries() {
	const [countries, setCountries] = useState<Country[]>([]);
	const [loading, setLoading] = useState(true);
	const [error, setError] = useState<Error | null>(null);

	useEffect(() => {
		const fetchCountries = async () => {
			try {
				setLoading(true);
				const response = await apiGet<Country[]>("/countries");
				if (response.success && response.data) {
					setCountries(response.data);
				} else {
					throw new Error(response.error || "Failed to fetch countries");
				}
			} catch (err) {
				setError(err instanceof Error ? err : new Error("Unknown error"));
			} finally {
				setLoading(false);
			}
		};

		fetchCountries();
	}, []);

	return { countries, loading, error };
}